if (!customElements.get('toast-notifications')) {
  customElements.define(
    'toast-notifications',
    class ToastNotifications extends HTMLElement {
      constructor() {
        super();
        this.classList.add('toast-container');
        this._unsub = null;
        this._lastKey = '';
        this._lastAt = 0;
        this.icons = {
          success: `<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.708 12.293a1 1 0 0 1 0 1.415l-7 7a1 1 0 0 1-1.415 0l-3-3a1 1 0 0 1 1.415-1.415L14 18.586l6.293-6.293a1 1 0 0 1 1.415 0M29 16A13 13 0 1 1 16 3a13.014 13.014 0 0 1 13 13m-2 0a11 11 0 1 0-11 11 11.01 11.01 0 0 0 11-11" fill="currentColor"/></svg>`,
          error: `<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3m0 24a11 11 0 1 1 11-11 11.01 11.01 0 0 1-11 11m-1-10v-7a1 1 0 0 1 2 0v7a1 1 0 0 1-2 0m2.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" fill="currentColor"/></svg>`,
          info: `<svg fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.852l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>`,
        };
      }

      connectedCallback() {
        this._attach();
      }

      disconnectedCallback() {
        if (this._unsub) {
          try { this._unsub(); } catch(_) {}
          this._unsub = null;
        }
      }

      _attach() {
        if (this._unsub) return; // already subscribed
        this._waitForPubSub((pubsub) => {
          this._unsub = pubsub.subscribe(PUB_SUB_EVENTS.toastShow, (event) => this._onToast(event));
        });
      }

      _onToast({ message, title = '', type = 'info', duration = TOAST_DURATION || 4000, link = '' } = {}) {
        if (!message) return;

        // de-dupe identical events within 750ms
        const key = `${type}|${title}|${message}`;
        const now = Date.now();
        if (key === this._lastKey && now - this._lastAt < 750) return;
        this._lastKey = key;
        this._lastAt = now;

        const toast = document.createElement('div');
        const a11y = type === 'error'
          ? { role: 'alert', 'aria-live': 'assertive' }
          : { role: 'status', 'aria-live': 'polite' };

        toast.className = `toast-item toast-item--${type}`;
        toast.setAttribute('role', a11y.role);
        toast.setAttribute('aria-live', a11y['aria-live']);

        // Make success toasts clickable to go to cart (but not when already on cart page)
        const isOnCartPage = window.location.pathname === '/cart';
        if ((type === 'success' || link) && !isOnCartPage) {
          toast.classList.add('toast-item--clickable');
          toast.style.cursor = 'pointer';
          toast.addEventListener('click', function() {
            window.location.href = link || '/cart';
          });
        }

        const titleHTML = title ? `<h4 class="toast-item__title">${title}</h4>` : '';
        const cartLink = link || '/cart';
        const cartBtnHTML = (type === 'success' && !isOnCartPage) ? `
          <div class="toast-item__actions">
            <a href="${cartLink}" class="toast-item__btn toast-item__btn--primary">Sepete Git</a>
          </div>
        ` : '';
        toast.innerHTML = `
          <div class="toast-item__icon">${this.icons[type] || this.icons.info}</div>
          <div class="toast-item__content">
            ${titleHTML}
            <p class="toast-item__message">${message}</p>
            ${cartBtnHTML}
          </div>
        `;

        this.prepend(toast);
        requestAnimationFrame(() => toast.classList.add('is-visible'));

        const removeToast = () => {
          toast.classList.remove('is-visible');
          toast.addEventListener('transitionend', () => toast.remove(), { once: true });
          setTimeout(() => { if (toast.isConnected) toast.remove(); }, 1000);
        };

        setTimeout(removeToast, duration);
      }

      _waitForPubSub(callback) {
        if (window.Shopify?.pubsub && typeof PUB_SUB_EVENTS !== 'undefined' && typeof TOAST_DURATION !== 'undefined') {
          callback(window.Shopify.pubsub);
        } else {
          setTimeout(() => this._waitForPubSub(callback), 50);
        }
      }
    }
  );
}
